jQuery(document).on('click', '.plupload_header', function(){
	jQuery(document).find('.moxie-shim-html5 input').click()
}).on('click', '.show-login-form', function(e){
	
	e.preventDefault();
	jQuery(document).find('.login-form-container').removeClass('hidden');
	jQuery(document).find('.registration-form-container').addClass('hidden');
}).on('click', '.show-registration-form', function(e){
	e.preventDefault();
	jQuery(document).find('.login-form-container').addClass('hidden');
	jQuery(document).find('.registration-form-container').removeClass('hidden');
}).on('forminator:form:submit:success', function(e,d) {
	if (e.target.dataset.formId == 1339 || e.target.dataset.formId == 1216) {
		document.forms['m3dreader__model-quote-form'].submit();	
	}
});

jQuery(document).ready(function($){

	let intervalId = setInterval(function() {
		let elm = jQuery(document).find('.plupload_droptext');
		let elm2 = jQuery(document).find('.plupload_header_title');
		// Stop the interval after 5 iterations
		if (elm.text() == 'Drag Files To Upload' && 'UPLOAD 3D FILES, CHOOSE MATERIAL,GET INSTANT QUOTE, & ADD TO CART TO ORDER.' == elm2.text()) {
			clearInterval(intervalId);
		}
		else{
			elm.text('Drag Files To Upload');
			elm2.text('UPLOAD 3D FILES, CHOOSE MATERIAL,GET INSTANT QUOTE, & ADD TO CART TO ORDER.');
		}
		
	}, 100); 

	"use strict"; // Start of use strict

  // Toggle the side navigation
	$("#sidebarToggle, #sidebarToggleTop").on('click', function(e) {
		$("body").toggleClass("sidebar-toggled");
		$(".sidebar").toggleClass("toggled");

	});

	// Close any open menu accordions when window is resized below 768px
	$(window).resize(function() {

		// Toggle the side navigation when window is resized below 480px
		if ($(window).width() < 480 && !$(".sidebar").hasClass("toggled")) {
		$("body").addClass("sidebar-toggled");
		$(".sidebar").addClass("toggled");
		};
	});


})


